import { useState, useEffect } from 'react';
import styled from '@emotion/styled'
import { Button, CardActions } from '@mui/material';

import { Link } from 'react-router-dom';

// useMutation
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAppt } from '../apiService';

// snackbar
import useSnackbarStore from '../../../store/snackbar';

import { useNewEvent } from '../../../contexts/NewEvent';

import Dialog from '../../../utils/utilities/Dialog';

import EditCheckout from '../../Checkout/EditCheckout';

import { useCheckoutContext } from '../../../contexts/Checkout';

// mui icons
import AutoDeleteRoundedIcon from '@mui/icons-material/AutoDeleteRounded';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';


const AppointmentMenu = ({ event = {}, setAnchorEl = null, ...props }) => {
  const { setAppointment } = useCheckoutContext() || {};
  const queryClient = useQueryClient();

  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  const { editEvent } = useNewEvent();

  const moveToCheckout = (e) => {
    e.stopPropagation();
    console.log(event, "event");
    setAppointment(event);
    if (setAnchorEl) setAnchorEl(null);
  }

  const handleEdit = (e) => {
    e.stopPropagation();
    if (setAnchorEl) setAnchorEl(null);
    console.log(event, "event");
    editEvent(event.appointment_id);
  }

  const { mutate: deleteApptMutation } = useMutation({
    mutationFn: deleteAppt,
    onSuccess: () => {
      showSnackbar('Deleted successfully!', 'success');
      console.log("deleted");
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
      queryClient.invalidateQueries({ queryKey: ['appointments', 'calendar'] });
    }
  });

  const additionalButtons = event.is_recurring && event.recurring_group_id ? [
    { text: "Delete All Recurring Events", func: () => deleteApptMutation({id: event.appointment_id, remove_all: true}), variant: "outlined", color: "secondary" }
  ] : []

  if (["cancelled", "no_show"].includes(event.status)) return null;

  // if (event.invoice_status) return null;

  return (
  <CardActions sx={{justifyContent: "flex-end"}}>
    {!event.invoice_status ? <Button size="small" variant="contained" color="secondary" startIcon={<EditCalendarRoundedIcon fontSize="small" />} onClick={handleEdit}>Edit</Button> : null}
    {event.status !== "completed" ? <Dialog title="Confirm Cancel Appointment?" size="sm" toggle={<Button size="small" startIcon={<AutoDeleteRoundedIcon fontSize="small"  />} variant="outlined">Delete</Button>} saveText="Delete" text="Deleting this appointment will permanently remove it from the system. Are you sure you want to continue?" saveFunc={() => deleteApptMutation({id: event.appointment_id})} additionalButtons={additionalButtons} /> : null}
    {!event.invoice_status && event.appointment_type === "customer" ? <Button fullWidth startIcon={<ShoppingCartCheckoutRoundedIcon />} size="small" variant="contained" onClick={moveToCheckout}>Checkout</Button> : null}
    {event.invoice_status && event.invoice_status !== "paid" && event.appointment_type === "customer" ? <Button fullWidth startIcon={<MonetizationOnRoundedIcon />} variant="contained" color="success" component={Link} to={`/invoices/edit/${event.invoice_id}`}>Pay for appointment</Button> : null}
  </CardActions>
  );
};

export default AppointmentMenu;